
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#max-tricks_svg__clip0_1_2)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#FDD05D"}}),_c('path',{attrs:{"d":"M6.556 15.5L5 5.875l4.278 4.375L12 5l2.722 5.25L19 5.875 17.444 15.5H6.556zm10.888 2.625c0 .525-.31.875-.777.875H7.333c-.466 0-.777-.35-.777-.875v-.875h10.888v.875z","fill":"#FFB119"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"max-tricks_svg__clip0_1_2"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    